import React from 'react';
import './AddButton.css';
// import '../../common/CommonText.css'
// import '../../common/style.css'

const AddButtonWithPlus = ({ onClick, disabled = false }) => {
  return (
    <button
      className={`add-button-with-plus ${disabled ? "disabled" : ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
        <circle cx="9.13043" cy="9.13043" r="9.13043" fill="#094C80"/>
        <path d="M9.5 6.5V12.5M6.5 9.5H12.5" stroke="#FFF" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
      <span className='add-button-text'>New</span>
    </button>
  );
};

export default AddButtonWithPlus;
